import { Events, emit } from './events.js';
import { attachHoverFocus } from './interactions.js';

export class BaseInteractiveElement extends HTMLElement {
  constructor(options = {}) {
    super();
    this.__options = options;
  }
  connectedCallback() {
    try { this.#init(); } catch (_) {}
  }
  disconnectedCallback() {
    try {
      if (this.__onClick) this.removeEventListener('click', this.__onClick, true);
      if (this.__onKey) this.removeEventListener('keydown', this.__onKey, true);
      if (this.__detachHoverFocus) this.__detachHoverFocus();
    } catch (_) {}
  }
  #init() {
    const opts = this.__options || {};
    const baseClass = opts.baseClass;
    const eventGroup = opts.eventGroup; // e.g., Events.card or Events.productCard

    // Ensure base visual class SSR-safe, idempotent if already present
    try { if (baseClass) this.classList && this.classList.add(baseClass); } catch (_) {}

    const interactive = this.getAttribute('interactive');
    const selectable = this.getAttribute('selectable');
    const href = this.getAttribute('href');
    const isInteractive = interactive === '' || interactive === 'true' || !!href;
    const isSelectable = selectable === '' || selectable === 'true';

    try { if (window.store && window.store.debug) window.store.log(`[${baseClass||'component'}] init`, { interactive: isInteractive, selectable: isSelectable, href }); } catch (_) {}

    if (href && isInteractive) {
      this.setAttribute('role', 'link');
      this.setAttribute('tabindex', '0');
    } else if (isInteractive || isSelectable) {
      this.setAttribute('role', 'button');
      this.setAttribute('tabindex', '0');
    }

    this.__onClick = (ev) => {
      try {
        const innerLink = ev.target && ev.target.closest && ev.target.closest('a,button');
        if (innerLink && this.contains(innerLink)) return;

        if (href) {
          ev.preventDefault();
          ev.stopPropagation();
          try { window.location.assign(href); } catch (_) {}
          try { if (window.store && window.store.debug) window.store.log(`[${baseClass||'component'}] click -> navigate`, { href }); } catch (_) {}
          if (eventGroup && eventGroup.click) emit(eventGroup.click, { element: this, href }, this);
          return;
        }

        try { if (window.store && window.store.debug) window.store.log(`[${baseClass||'component'}] click`); } catch (_) {}
        if (eventGroup && eventGroup.click) emit(eventGroup.click, { element: this }, this);
        if (isSelectable) {
          const selected = this.hasAttribute('data-selected');
          this.toggleAttribute('data-selected', !selected);
          this.setAttribute('aria-pressed', String(!selected));
          try { if (window.store && window.store.debug) window.store.log(`[${baseClass||'component'}] select`, { selected: !selected }); } catch (_) {}
          if (eventGroup && eventGroup.select) emit(eventGroup.select, { element: this, selected: !selected }, this);
        }
      } catch (_) {}
    };
    this.__onKey = (ev) => {
      try { if (ev.key === 'Enter' || ev.key === ' ') { ev.preventDefault(); this.__onClick(ev); } } catch (_) {}
    };

    if (isInteractive || isSelectable || href) {
      this.addEventListener('click', this.__onClick, true);
      this.addEventListener('keydown', this.__onKey, true);
    }

    try {
      this.__detachHoverFocus = attachHoverFocus(this, {
        events: eventGroup ? {
          hoverStart: eventGroup.hoverStart,
          hoverEnd: eventGroup.hoverEnd,
          focus: eventGroup.focus,
          blur: eventGroup.blur,
          hoverChildStart: eventGroup.hoverChildStart,
          hoverChildEnd: eventGroup.hoverChildEnd,
        } : undefined,
        attrHover: 'data-hover',
        attrHoverChild: 'data-hover-child',
        ignoreInner: 'a,button'
      });
    } catch (_) {}
  }
}


